import { useEffect } from 'react';
import { useAccount, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { first } from 'lodash';
import { useFetchSecret } from './queries/useFetchSecret';
import { InitializeTelemetryForAuthenticatedUser } from '../utils/app-insights-utils';
import { secretNames } from '../constants/constants';

export const useAuthenticatedUserTelemetry = (): void => {
  const { accounts } = useMsal();
  const account = useAccount(first(accounts));
  const isAuthenticated = useIsAuthenticated();
  const instrumentationKey = useFetchSecret(secretNames.appInsightsInstrumentationKey);

  useEffect(() => {
    if (isAuthenticated && account && instrumentationKey) {
      InitializeTelemetryForAuthenticatedUser(account, instrumentationKey);
    }
  }, [isAuthenticated, account, instrumentationKey]);
};
